import gql from 'graphql-tag'


export const CREATE_ACCOUNT = gql`
    mutation createAcction(
        $channelId:String! 
        $displayName:String!
        $profileImageUrl:String!
        ){
        createAccount(
            channelId: $channelId 
            displayName: $displayName
            profileImageUrl: $profileImageUrl
            ){
                id
                channelId
                sessionId
                sessionTime
            }
    }
`;